export default __webpack_public_path__ + "static/media/3Estudiantes_combinado_scroll.62309bc9.png";